import { Components, Theme } from '@mui/material/styles';
import scssVariables from '@styles/variables.module.scss';

export const MuiAlert: Components<Theme>['MuiAlert'] = {
  defaultProps: {
    slotProps: {
      root: {
        elevation: 0,
      },
    },
  },
  styleOverrides: {
    root: {
      // gets a border from our Paper styling otherwise
      '&:not(.MuiAlert-outlined)': {
        border: 'none',
      },
    },

    standardError: {
      backgroundColor: scssVariables.ColorError10,
      color: scssVariables.ColorError100,
      '& .MuiAlert-icon': {
        color: scssVariables.ColorError100,
      },
    },
    standardWarning: {
      backgroundColor: scssVariables.ColorWarning10,
      color: scssVariables.ColorWarning100,
      '& .MuiAlert-icon': {
        color: scssVariables.ColorWarning100,
      },
    },
    standardInfo: {
      backgroundColor: scssVariables.ColorInfo10,
      color: scssVariables.ColorInfo100,
      '& .MuiAlert-icon': {
        color: scssVariables.ColorInfo100,
      },
    },
    standardSuccess: {
      backgroundColor: scssVariables.ColorSuccess10,
      color: scssVariables.ColorSuccess100,
      '& .MuiAlert-icon': {
        color: scssVariables.ColorSuccess100,
      },
    },
  },
};
